import { motion } from "framer-motion";
import {
  ShieldCheck,
  FileText,
  HardHat,
  MessageSquare,
  Users,
  Layers,
} from "lucide-react";

const reasons = [
  {
    icon: ShieldCheck,
    title: "Single-point responsibility",
    text: "One accountable partner owns your entire project — no blame-shifting between multiple contractors.",
  },
  {
    icon: FileText,
    title: "Clear and transparent work scope",
    text: "You know exactly what is included, so there are no surprises once work begins.",
  },
  {
    icon: HardHat,
    title: "Dedicated site supervision",
    text: "Active on-site oversight keeps quality, safety and timelines on track.",
  },
  {
    icon: MessageSquare,
    title: "Regular work-progress communication",
    text: "Consistent updates keep you informed about progress at every stage.",
  },
  {
    icon: Users,
    title: "Skilled workforce coordination",
    text: "The right skilled hands are coordinated for each task, at the right time.",
  },
  {
    icon: Layers,
    title: "Construction and renovation under one system",
    text: "From new builds to upgrades, everything runs through one dependable system.",
  },
];

export const WhyChooseNC = () => {
  return (
    <section id="why" className="bg-secondary/50 py-12 sm:py-20">
      <div className="container-nc">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold">
            Why choose NC
          </span>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground text-balance sm:text-4xl">
            Built on accountability, not handovers
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            NC removes the friction of managing many contractors by taking ownership of the
            whole project — with clear scope and active supervision.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {reasons.map((reason, i) => (
            <motion.div
              key={reason.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.08, ease: "easeOut" }}
              className="flex h-full flex-col rounded-xl border border-border bg-card p-5 shadow-card sm:p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-gold/12 text-gold">
                <reason.icon className="h-6 w-6" />
              </span>
              <h3 className="mt-4 text-lg font-bold text-foreground">{reason.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{reason.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
